import React from 'react';
import moment from 'moment';

const tableColumns = [
    'Name',
    'Email',
    'Date Created',
    'AI Agent',
    'Client Hotel',
    'Created By',
];

const UsersNeedHelpTable = ({
    rows,
    loading,
    loadingMore,
    hasMore,
    onScrollEnd,
    scrollContainerRef,
}: {
    rows?: any[];
    loading?: boolean;
    loadingMore?: boolean;
    hasMore?: boolean;
    onScrollEnd?: () => void;
    scrollContainerRef?: React.RefObject<HTMLDivElement>;
}) => {
    return (
        <div className='overflow-x-auto border border-1 rounded-xl dark:border-borderColor-darkMode'>
            <div
                ref={scrollContainerRef}
                onScroll={onScrollEnd}
                className='overflow-y-auto'
                style={{ maxHeight: '600px' }}
            >
                <table className='min-w-full bg-white dark:bg-black dark:text-white min-h-[220px]'>
                    <thead className='sticky top-0 z-10 bg-white dark:bg-black text-left text-sm font-medium text-black dark:text-white'>
                        <tr>
                            {tableColumns.map((column) => (
                                <th key={column} className='px-4 py-3 min-w-[180px]'>
                                    {column}
                                </th>
                            ))}
                        </tr>
                    </thead>

                    <tbody>
                        {loading && (!rows || rows.length === 0) &&
                            Array.from({ length: 8 }).map((_, i) => (
                                <tr key={`s-${i}`} className='animate-pulse'>
                                    {Array.from({ length: 6 }).map((__, j) => (
                                        <td key={`c-${i}-${j}`} className='px-4 py-4'>
                                            <div className='h-4 bg-gray-200 dark:bg-gray-700 rounded w-3/4' />
                                        </td>
                                    ))}
                                </tr>
                            ))}

                        {!loading && (!rows || rows.length === 0) && (
                            <tr>
                                <td colSpan={6} className='px-4 py-8 text-center text-gray-500 dark:text-gray-400'>
                                    No data currently available
                                </td>
                            </tr>
                        )}

                        {rows && rows.length > 0 && rows.map((row: any, idx: number) => {
                            const worker =
                                row?.aiAgent
                                    ? row.aiAgent[0].toUpperCase() + row?.aiAgent?.slice(1).toLowerCase()
                                    : row?.aiAgent;
                            return (
                                <tr
                                    key={`${row?.id || row?.email || 'row'}-${idx}`}
                                    className='hover:bg-gray-50 dark:hover:bg-bgColor-darkMode text-sm border-b'
                                >
                                    <td className='px-4 py-4'>{row?.name || '--'}</td>
                                    <td className='px-4 py-4'>{row?.email || '--'}</td>
                                    <td className='px-4 py-4'>
                                        {row?.createdAt
                                            ? moment(row.createdAt).format('DD-MM-YYYY hh:mm:ss')
                                            : '--'}
                                    </td>
                                    <td className='px-4 py-4'>{worker || '--'}</td>
                                    <td className='px-4 py-4'>{row?.clientHotel || '--'}</td>
                                    <td className='px-4 py-4'>
                                        <div className='flex flex-col'>
                                            <span className='font-medium'>
                                                {row?.userInfo?.username || '--'}
                                            </span>
                                            <span className='text-xs text-gray-500 dark:text-gray-400'>
                                                {row?.userInfo?.email || row?.createdByEmail || '--'}
                                            </span>
                                        </div>
                                    </td>
                                </tr>
                            )
                        })}

                        {loadingMore && rows && rows.length > 0 && (
                            <tr>
                                <td colSpan={6} className='px-4 py-5'>
                                    <div className='flex items-center justify-center gap-2 text-sm text-gray-500 dark:text-gray-400'>
                                        <svg className='h-5 w-5 animate-spin text-gray-400' viewBox='0 0 24 24' fill='none'>
                                            <circle className='opacity-25' cx='12' cy='12' r='10' stroke='currentColor' strokeWidth='4' />
                                            <path className='opacity-75' fill='currentColor' d='M4 12a8 8 0 018-8v4A4 4 0 008 12H4z' />
                                        </svg>
                                        <span>Loading more...</span>
                                    </div>
                                </td>
                            </tr>
                        )}

                        {!loading && !loadingMore && rows && rows.length > 0 && hasMore === false && (
                            <tr>
                                <td colSpan={6} className='px-4 py-4 text-center text-xs text-gray-400'>
                                    All requests loaded
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default UsersNeedHelpTable;